<template>
  <div class="repair-list-export" ref="repairListExport">
    <div class="repair-list-header">
      <h1 class="title">技术服务部维修报价单</h1>
    </div>
    <!-- 客户信息 -->
    <table class="info-table">
      <tr>
        <td class="label">客户名称：</td>
        <td class="value">{{ orderResult.clientName || '/' }}</td>
        <td class="label">联系人：</td>
        <td class="value">{{ orderResult.linkman || '/' }}</td>
      </tr>
      <tr>
        <td class="label">联系电话：</td>
        <td class="value">{{ orderResult.linkmanPhone || '/' }}</td>
        <td class="label">传真：</td>
        <td class="value">/</td>
      </tr>
    </table>

    <!-- 主要维修项目表格 -->
    <table class="main-table">
      <caption style="text-align: left; font-weight: bold; margin-bottom: 10px;">维修清单</caption>
      <thead>
        <tr>
          <th>设备名称</th>
          <th>设备条码号或桑达标</th>
          <th>故障现象</th>
          <th>故障原因</th>
          <th>维修项</th>
          <th>费用(元)</th>
          <th>是否同意维修</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, rowIndex) in tableRows">
          <!-- 详情行 -->
          <tr v-if="row.type === 'detail'" :key="`detail-${rowIndex}`">
            <!-- 设备名称 -->
            <td v-if="rowIndex === 0" :rowspan="tableRows.length - 1" class="equipment-name">
              {{ row.expenseItem.equipmentName || '-' }}
            </td>
            <!-- 设备条码号或桑达标 -->
            <td v-if="rowIndex === 0" :rowspan="tableRows.length - 1">
              {{ row.expenseItem.equipmentSn || '-' }}
            </td>
            <!-- 故障现象 -->
            <td v-if="rowIndex === 0" :rowspan="tableRows.length - 1">
              {{ row.expenseItem.faultDesc || '-' }}
            </td>
            <!-- 故障原因 -->
            <td class="maintenance-name">
              {{ row.expenseItem.reason || '-' }}
            </td>
            <!-- 维修项 -->
            <td class="maintenance-name">
              {{ row.expenseItem.maintenance || '-' }}
            </td>
            <!-- 费用 -->
            <td class="material-fee">
              {{ formatPrice(row.expenseItem.totalAmount) }}
            </td>
            <!-- 是否同意维修 -->
            <td v-if="rowIndex === 0" :rowspan="tableRows.length - 1"></td>
          </tr>
          <!-- 汇总行 -->
          <tr v-else class="summary-row" :key="`summary-${rowIndex}`">
            <td colspan="5" class="summary-label">共计：</td>
            <td class="summary-material">{{ formatPrice(row.expenseItem.totalAmount) }}</td>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="parts-table">
      <caption style="text-align: left; font-weight: bold; margin-bottom: 10px;">配件明细</caption>
      <thead>
        <tr>
          <th>料号</th>
          <th>名称</th>
          <th>数量</th>
          <th>单价</th>
          <th>仓库</th>
          <th>货位</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row) in allPartsDetails">
          <tr>
            <td>{{ row.code || '-' }}</td>
            <td>{{ row.name || '-' }}</td>
            <td>{{ row.num || '-' }}</td>
            <td>{{ formatPrice(row.price) }}</td>
            <td>{{ row.warehouseName || '-' }}</td>
            <td>{{ row.storageName || '-' }}</td>
          </tr>
        </template>
      </tbody>
    </table>

    <!-- 收款账户信息 -->
    <div class="account-section">
      <div class="account-title">收款账户信息</div>
      <table class="account-table">
        <tr>
          <td class="account-label">名称</td>
          <td class="account-value">深圳桑达银络科技有限公司</td>
        </tr>
        <tr>
          <td class="account-label">税号</td>
          <td class="account-value">91440300731107397F</td>
        </tr>
        <tr>
          <td class="account-label">开户银行</td>
          <td class="account-value">工行深圳华强支行</td>
        </tr>
        <tr>
          <td class="account-label">银行账户</td>
          <td class="account-value">4000022109200053678</td>
        </tr>
      </table>
    </div>

    <!-- 维修凭证图片：存在时展示，导出 Word 时会包含 -->
    <div v-if="repairImageList.length" class="repair-url-section">
      <div class="repair-url-title">维修凭证</div>
      <div class="repair-url-content">
        <img v-for="(item, index) in repairImageList" :key="index" :src="item.fullUrl" :alt="item.name || '维修凭证'"
          class="repair-image" crossorigin="anonymous" />
      </div>
    </div>

    <!-- 签名和日期 -->
    <div class="signature-section">
      <div class="signature-item">
        <span>客户服务部</span>
      </div>
      <div class="signature-item">
        <span>签字：</span>
      </div>
      <div class="signature-item">
        <span>{{ formatDate(orderResult.orderTime || orderResult.createTime) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailType41Export',
  props: {
    orderResult: {
      type: Object,
      default: () => ({})
    },
    detailResults: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  computed: {
    // 将detailResults转换为expenseItems结构，根据maintenance字段分组
    expenseItems() {
      const groups = {}
      this.detailResults.forEach(detail => {
        // 使用maintenance字段作为分组键，如果没有则使用默认值
        const groupKey = detail.maintenance || '未分类'

        if (!groups[groupKey]) {
          // 初始化维修项，从第一个明细中提取设备信息
          groups[groupKey] = {
            reason: detail.reason || '',
            maintenance: groupKey, // 维修项名称
            equipmentCode: this.orderResult.code || '',
            equipmentName: this.orderResult.name || '',
            equipmentSn: this.orderResult.sn || '',
            faultDesc: this.orderResult.detail || '',
            // 统计字段
            totalAmount: 0, // 费用合计
            totalParts: 0, // 配件数量合计
            children: []
          }
        }

        // 添加配件明细
        const partDetail = {
          code: detail.code,
          name: detail.name,
          num: detail.num || 0,
          price: (detail.price || 0) / 100, // 分转元
          warehouseName: detail.warehouseName,
          storageName: detail.storageName
        }

        groups[groupKey].children.push(partDetail)

        // 累计统计
        groups[groupKey].totalAmount += partDetail.price * partDetail.num
        groups[groupKey].totalParts += partDetail.num
      })

      // 转换为数组并返回
      return Object.values(groups)
    },
    // 配件清单分组（相同料号合并，数量相加）
    allPartsDetails() {
      const partsMap = {}

      // 收集所有配件
      this.expenseItems.forEach(expenseItem => {
        expenseItem.children.forEach(detail => {
          const code = detail.code || ''

          if (!partsMap[code]) {
            // 首次遇到该料号，创建新记录
            partsMap[code] = {
              code: detail.code,
              name: detail.name,
              num: detail.num || 0,
              price: detail.price || 0,
              warehouseName: detail.warehouseName,
              storageName: detail.storageName
            }
          } else {
            // 已存在该料号，数量相加
            partsMap[code].num += (detail.num || 0)
          }
        })
      })

      // 转换为数组并返回
      return Object.values(partsMap)
    },
    // 扁平化的表格行数据
    tableRows() {
      const rows = []
      const expenseItem = {
        reason: '',
        maintenance: '',
        equipmentCode: '',
        equipmentName: '',
        equipmentSn: '',
        faultDesc: '',
        totalAmount: 0,
        totalParts: 0,
      }
      this.expenseItems.forEach((item, expenseIndex) => {
        rows.push({
          type: 'detail',
          expenseItem: item
        })
        expenseItem.totalAmount += item.totalAmount
      })
      rows.push({
        type: 'summary',
        expenseItem
      })
      return rows
    },
    // 维修凭证图片列表（支持多图，逗号分隔；使用完整 URL 便于导出 Word 时包含图片）
    repairImageList() {
      const raw = this.orderResult.repairUrl
      if (!raw || typeof raw !== 'string') return []
      return raw.split(',').map(segment => {
        const part = segment.trim()
        if (!part) return null
        const url = part.includes('?fileName=') ? part.split('?fileName=')[0].trim() : part
        const name = part.includes('?fileName=') ? (part.split('?fileName=')[1] || '').trim() : ''
        const fullUrl = this.interceptImg(url)
        return { url, name, fullUrl }
      }).filter(Boolean)
    }
  },
  methods: {
    // 格式化价格
    formatPrice(price) {
      if (!price || price === 0) return '0'
      return Number(price).toFixed(2)
    },
    // 获取维修项小计
    getExpenseItemTotal(expenseItem) {
      const materialFee = this.getTotalAmount(expenseItem)
      const repairFee = Number(expenseItem.repairAmount || 0)
      return materialFee + repairFee
    },
    // 获取材料费合计
    getTotalAmount(expenseItem) {
      // 如果已经统计过，直接返回
      if (expenseItem.totalAmount !== undefined) {
        return expenseItem.totalAmount
      }
      // 否则计算
      let sum = 0
      expenseItem.children.forEach(detail => {
        sum += (detail.price || 0) * (detail.num || 0)
      })
      return sum
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) {
        const now = new Date()
        return `${now.getFullYear()}年${String(now.getMonth() + 1).padStart(2, '0')}月${String(now.getDate()).padStart(2, '0')}日`
      }
      const date = new Date(dateStr)
      return `${date.getFullYear()}年${String(date.getMonth() + 1).padStart(2, '0')}月${String(date.getDate()).padStart(2, '0')}日`
    },
    // 获取备注文本
    getRemarkText() {
      const orderCode = this.orderResult.orderCode || ''
      const defaultRemark = `请在服务收费清单备注审批号:${orderCode} 维修使用 以免当配件发走`
      return this.orderResult.remark || defaultRemark
    }
  }
}
</script>

<style scoped>
.repair-list-export {
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  background: #fff;
}

.repair-list-header {
  text-align: center;
  margin-bottom: 20px;
}

.export-types-selector {
  margin-bottom: 16px;
  text-align: left;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  text-align: center;
}

.info-table {
  width: 100%;
  margin-bottom: 20px;
}

.info-table td {
  padding: 8px;
}

.info-table .label {
  width: 100px;
  font-weight: bold;
}

.info-table .value {
  width: 200px;
}

.main-table {
  width: 100%;
  margin-bottom: 20px;
  border-collapse: collapse;
  font-size: 12px;
  border: none;
}

.main-table th,
.main-table td {
  padding: 8px;
  text-align: center;
  border: 1px solid #000;
}

.main-table th {
  background: #f5f5f5;
  font-weight: bold;
}

.main-table .equipment-name {
  font-weight: bold;
}

.main-table .parts-list {
  text-align: left;
  padding-left: 10px;
}

.main-table .maintenance-name {
  font-weight: bold;
  text-align: center;
}

.main-table .material-fee,
.main-table .repair-fee,
.main-table .subtotal {
  text-align: center;
  padding-right: 10px;
}

.main-table .summary-row {
  background: #f9f9f9;
  font-weight: bold;
}

.main-table .summary-label {
  text-align: left;
  padding-right: 10px;
}

.main-table .summary-material,
.main-table .summary-repair,
.main-table .summary-total {
  text-align: center;
  padding-right: 10px;
}

.fee-summary {
  margin-bottom: 20px;
}

.fee-item {
  margin-bottom: 10px;
}

.fee-label {
  font-weight: bold;
  margin-right: 10px;
}

.parts-table {
  width: 100%;
  margin-bottom: 20px;
  border-collapse: collapse;
  font-size: 12px;
  border: none;
}

.parts-table th,
.parts-table td {
  padding: 8px;
  text-align: center;
  border: 1px solid #000;
}

.parts-table th {
  background: #f5f5f5;
  font-weight: bold;
}

.parts-table .parts-name {
  padding-left: 10px;
}

.notes-section {
  margin-bottom: 20px;
}

.note-item {
  margin-bottom: 15px;
}

.note-label {
  font-weight: bold;
  margin-right: 10px;
}

.note-content {
  display: inline-block;
  vertical-align: top;
}

.account-section {
  margin-top: 24px;
  margin-bottom: 20px;
}

.account-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
}

.account-table {
  border-collapse: collapse;
  font-size: 12px;
  border: none;
}

.account-table td {
  border: 1px solid #000;
  padding: 6px 10px;
}

.account-table .account-label {
  width: 90px;
  color: #333;
  vertical-align: top;
}

.account-table .account-value {
  min-width: 200px;
}

.repair-url-section {
  margin-top: 24px;
  margin-bottom: 16px;
}

.repair-url-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
}

.repair-url-content {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
}

.repair-url-content .repair-image {
  max-width: 280px;
  max-height: 200px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  vertical-align: top;
}

.signature-section {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.signature-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  text-align: left;
  width: 200px;
  justify-content: flex-start;
}

.signature-line {
  display: inline-block;
  width: 150px;
  height: 1px;
  border-bottom: 1px solid #000;
  margin-left: 10px;
}
</style>
